import { entities } from "./entities";
import { masquerades } from "./masquerades";

export const masquerading = {
  entities,
  masquerades,
};
